import { render } from "./product-usp.vue?vue&type=template&id=3ffff9a7"
import script from "./product-usp.vue?vue&type=script&lang=js"
export * from "./product-usp.vue?vue&type=script&lang=js"

import "./product-usp.vue?vue&type=style&index=0&id=3ffff9a7&lang=scss"

import exportComponent from "/Users/bornasepic/Desktop/projects/grau/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__